import mq from 'js-mq';
import $ from 'jquery';

/* Reset xs #nav-main toggle styles when not-xs */

$(_ => {

  const $navMain = $('#nav-main');
  const $contents = $navMain.find('.js-toggle-content');
  const $buttons = $navMain.find('.js-toggle-btn');

  mq.on('not-xs', _ => {
    $contents.attr('style', '');
    $buttons.removeClass('open');
  });

});
